const TargetData = {
    "מבצעים": [
        {
            name: "יעד מזון ומים",
            connections: [
                "מענה רשותי לאספקה וחלוקת מים.",
                "מענה רשותי לחלוקת מזון.",
                "תוכנית להנגשת מידע אודות החנויות לממכר מזון הפתוחות בחירום."
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                "מענה רשותי למחוסרי מרחב מוגן.",
                "איתור מחסות ציבוריים והפעלתם.",
                "מנגנון לגיבוש תמ\"צ מפונים ומתפנים.",
                "מוכנות מתקני קליטה.",
                "כשירות מקלטים ציבוריים ומנגנון לפתיחתם."
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                "תוכנית להקמת מרכז גנרציה ותפעולו.",
                "תוכנית סיוע לחלוקת תרופות.",
                "תוכנית להנגשת מידע אודות אופן קבלת שירותי רפואה בקהילה בחירום."
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                "תוכנית הצבת כוח-אדם למשימות הרשות.",
                "מנגנון להעלאת התייצבות עובדים ותגבור כוח-אדם חיצוני.",
                "תוכנית לפתיחת מסגרות לילדי עובדים.",
                "תוכנית תמיכה ומניעת שחיקה לעובדים."
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                "וידוא תקינות גנרציה במתקנים חיוניים של הרשות.",
                "איתור מרה\"פ חלופי.",
                "הגדרה ורכש של מלאי דלק לתדלוק גנרטורים.",
                "בניית יכולת הפצת מידע בהיעדר תקשורת סלולרית וקווית."
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                "תוכניות הסברה נצורות לאתגרים ולצרכים הצפויים ולתוכניות המענה הרשותיות.",
                "בניית פלטפורמות מגוונות ויתירות להפצת מידע ומענה לתושבים."
            ]
        }
    ],
    "אוכלוסיה": [
        {
            name: "יעד מזון ומים",
            connections: [
                'הכנת בני נוער מתנדבים לסיוע בחלוקת מים, מזון ועוד.'
                        ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'מנגנון לגיבוש תמ"צ קליטה של תושבים מחוץ לרשות ותמ"צ מפונים תושבי רשות.',
                "מנגנון לגיבוש תמ\"צ מחוסרי קורת גג וגיבוש מאגר פתרונות דיור חלופי.",
                "מוכנות וכשירות לניהול מתקני הקליטה.",
                "תוכנית לניהול מחסות ציבוריים."
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'מיפוי אוכלוסייה: מונשמים/ נתמכי נשימה, מרותקים, ללא עורף משפחתי.',
                "תוכנית לניהול מרכז גנרציה.",
                "הכרת המרפאות האחודות בשטח הרשות.",
                "הכרת המרפאות עם מרחב מוגן וגנרציה.",
                "מוכנות וכשירות צוותי התערבות בזירת אירוע צוות 'קו פתוח' במוקד."
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'בניית מערך מתנדבים ומשאבי קהילה לתגבור כוח-אדם למשימות הרשות.',
                "תוכנית כ\"א לביצוע משימות המכלול: הצבת עובדים, מיפוי פערי התייצבות, מענה לעובדים, איתור והכשרת מתנדבים."
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'מיפוי אוכלוסייה של מונשמים ונתמכי נשימה ודרכי התקשורת עימם, כולל כתובת מגורים.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'מוכנות וכשירות צוות "קו פתוח" במוקד.',
                'גיבוש מידע אודות פעילות השירותים בחירום: בריאות, רווחה ודת. מידע מומלץ למפונים ולנפגעים.',
                'גיבוש מסרים ומידע תומך חוסן לאוכלוסייה.'
            ]
        }
    ],
    "חינוך": [
        {
            name: "יעד מזון ומים",
            connections: [
                'תכנון תגבור כוח-אדם מקצועי (חינוכי וטיפולי) למשימות מכלול אוכלוסייה.'
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'מוכנות וכשירות כוח-אדם וסגל חינוכי לניהול מתקני הקליטה.',
                'ניהול סל קליטה לצורכי המפונים.',
                'תוכנית חינוך ופעילות הפגה לילדי הנקלטים.'
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'גיבוש כוח-אדם מקצועי טיפולי לתמיכה נפשית (שפ"ח)לעיבוי צוותי ההתערבות.'
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'בניית מערך מתנדבים בני נוער לתגבור כוח-אדם למשימות הרשות.',
                'פתיחת מסגרות לילדי עובדים.',
                'תוכנית כוח-אדם לביצוע משימות המכלול: הצבת עובדים, מיפוי פערי התייצבות, מענה לעובדים, איתור והכשרת מתנדבים.'
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'מוכנות וכשירות הרדיו החינוכי ברשות (כוח-אדם, מיגון, גנרציה), כולל אפשרות דילוג.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'שימוש בפלטפורמות המידע של הסגל החינוכי עם הורי הילדים כפלטפורמה נוספת להפצת מידע בחירום.'
            ]
        }
    ],
    "מידע לציבור": [
        {
            name: "יעד מזון ומים",
            connections: [
                'גיבוש תוכנית הסברה והפצת מידע על חנויות לממכר מזון הפתוחות בחירום ברשות, אופן אספקה וחלוקה של מים ומזון.'
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'מנגנון להנגשת פתרונות ציבוריים (מקלטים, מחסות) לתושבים ללא מרחב מוגן ותיאום ציפיות לגבי התנאים.',
                'גיבוש מידע למפונים במתקני קליטה והקמת לשכת מידע.'
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'גיבוש תוכנית הסברה והפצת מידע על אופן פעילות שירותי הרפואה ברשות, הקמת מרכז גנרציה ואופן חלוקת תרופות.'
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'גיבוש תוכנית הסברה לעידוד התנדבות בקרב תושבי הרשות.',
                'תוכנית כוח-אדם לביצוע משימות המכלול: הצבת עובדים, מיפוי פערי התייצבות, מענה לעובדים, איתור והכשרת מתנדבים.'
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'גיבוש תוכנית הסברה והפצת מידע על תחנות צי ברזל, אספקת גפ"ם, שיבושים באספקת מים בבניינים גבוהים ואופן קבלת מידע בהיעדר תקשורת.',
                'בניית יכולות להנחיית התושבים בהיעדר התרעה ותקשורת. וידוא גנרציה למערכות החיוניות הנדרשות להפצת מידע.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'תוכנית הסברה תומכת לחוסן התושבים.',
                'בנייה ועיבוי של פלטפורמות מגוונות להפצת מידע ומענה והכרות התושבים עימם.',
                'בניית יכולות להנחיית תושבים בהיעדר התרעה ותקשורת.',
                'מוכנות וכשירות המוקד רשותי ובעל רציפות תפקודית (כוח-אדם, מיגון, גנרציה), כולל דילוג/ הרחבת מוקד.',
                ' כתיבת תוכניות הסברה לתרחישים השונים ולתוכניות הרשות, בהתאמה לאוכלוסיות מיוחדות, שפות, מגדרים.',
            ]
        }
    ],
    "הנדסה ותשתיות": [
        {
            name: "יעד מזון ומים",
            connections: [
                'איתור מרחבים מוגנים לטובת הקמת תחנות לחלוקת מים.'
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'איתור מחסות ציבוריים.',
                'מיפוי מחוסרי מרחב מוגן ברשות.',
                'מיפוי מרחבים מוגנים ציבוריים ברשות: מקלטים ציבוריים מקלטי מוס"ח ומקלטים במתקני הקליטה.'
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'איתור מבנה עם מיגון תקני להקמת מרכז גנרציה.',
                'וידוא מלאי דלק לגנרטורים וליווי חשמלאי למרכז גנרציה.'
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'תוכנית כוח-אדם לביצוע משימות המכלול: הצבת עובדים, מיפוי פערים צפויים בחירום, גיבוש מענה לעובדים, איתור והכשרת מתנדבים.'
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'מיפוי בניינים גבוהים בהם אספקת המים נשענת על משאבות.',
                'איתור מרה"פ חלופי.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'איתור מבנים עם מיגון תקני להקמת לשכות מידע.',
                'איתור מוקד חלופי עם מיגון.'
            ]
        }
    ],
    "לוגיסטיקה ותפעול": [
        {
            name: "יעד מזון ומים",
            connections: [
                'תוכנית להקמת תחנות לחלוקת מים ותיאום מול תאגיד המים.',
                'הכרת סופרים ברזל בשטח הרשות.',
                'חוזה נצור עם ספק מזון לאוכלוסיית רווחה לחלוקה עד הבית.',
                'הקצאת רכבים למשימות חלוקת מים ומזון.'
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'תוכנית להקמת מתקני הקליטה ומענה לוגיסטי: ציוד הלנה ופס"ח, אספקת מזון, הסעות נקלטים ותכנון רכש.',
                'תוכנית לוגיסטית למחסות ציבוריים: אספקת מים, שירותים כימיים, ערכת עזרה ראשונה ואמצעי כריזה.'
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'תוכנית הקמת מרכז גנרציה ומענה לוגיסטי: גנרציה, סניטציה, מים, אמצעי בטיחות.',
                'סיוע בשינוע נתמכי נשימה.',
                'הקצאת רכבים למשימת חלוקת תרופות.'
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'בניית מערך הסעות, קייטרינג ומעטפת לוגיסטית לעובדים.',
                'תוכנית כוח-אדם לביצוע משימות המכלול: הצבת עובדים, מיפוי פערי התייצבות, מענה לעובדים, איתור והכשרת מתנדבים.'
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'הכנה לגנרציה (תשתית) ותקינות גרציה במתקנים חיוניים של הרשות: מרה"פ, מוקד, מרכז גנרציה ומתקני קליטה.',
                'וידוא מלאי דלק לכל צורכי הרשות.',
                'הכרה של תחנות צי ברזל בשטח הרשות.',
                'מנגנון לגיבוש תמ"צ פערים בדלק וגז ברשות וכשירות גנרציה.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'גיבוש מידע על פעילות השירותים בחירום: פינוי אשפה, תחבורה ציבורית, מזון, דלק, גז ועוד.',
                'סיוע בפתיחת לשכות מידע.',
                'וידוא חוזה נצור מול בית דפוס מבוסס גנרטור.',
                'תכנון רכש אמצעים אנלוגיים ואמצעי שטח (למשל כריזה).'
            ]
        }
    ],
    'מינהל כללי ומשא"ן': [
        {
            name: "יעד מזון ומים",
            connections: [
                'איתור ותכנון כוח-אדם (כולל כוח-אדם עם רכבים) למשימות חלוקת מים ומזון.'
            ]
        },
        {
            name: "יעד מחסה הולם",
            connections: [
                'איתור ותכנון כוח-אדם למשימות תפעול של מתקני הקליטה ומחסות ציבוריים.'
            ]
        },
        {
            name: "יעד שירותי רפואה",
            connections: [
                'איתור ותכנון כוח-אדם למשימות סיוע ושינוע של נתמכי נשימה למרכז גנרציה.',
                'איתור כוח-אדם עם כלי רכב למשימת חלוקת תרופות.'
            ]
        },
        {
            name: "מאפשר כוח-אדם",
            connections: [
                'תוכנית הצבת כוח-אדם (מתנדבים ועובדים) למשימות הרשות. חיזוי פערי כוח-אדם בחירום ובניית תוכנית להעלאת ההתייצבות.',
                'תיאום ציפיות עם העובדים ואישור עובדים חיוניים. מנגנון לגיבוש תמ"צ התייצבות עובדים.',
                'גיבוש פוטנציאל ילדי עובדים למסגרות.',
                'בניית תוכנית תמיכה ומניעת שחיקה לעובדים.',
                'גיוס ורישום מתנדבים להגדלת מאגר כוח-אדם הרשותי.'
            ]
        },
        {
            name: "מאפשר אנרגיה",
            connections: [
                'כשירות ורציפות בהפעלת מערכות התקשוב והמידע.',
                'מנגנון ליצירת קשר והגדרת התייצבות עובדים בהיעדר תקשורת סלולרית ו/או קווית.',
                'מיפוי יכולות כריזה במרחב הרשות.'
            ]
        },
        {
            name: "מאפשר מידע לציבור",
            connections: [
                'איתור ותכנון כוח-אדם למשימות מכלול מידע לציבור: כוח-אדם מקצועי, מובילי דעת קהל, דוברי שפות, כוח-אדם לתגבור יכולות מענה והפצת מידע.',
                'תמיכה ווידוא רציפות בהפעלת מערכות הפצת המידע והמענה לתושבים.'
            ]
        }
    ]
};

export default TargetData;